module.exports = __webpack_public_path__ + "static/media/blinko-azul.3f01e3ed.png";